@if (hasSelectAll) {
  <app-checkbox
    id="select-all-checkmark"
    class="my-4 block"
    [ngModel]="selectAllCheckmark"
    [valueLabel]="buildTranslationKey('selectAll') | translate: { count: itemsList?.length }"
    (click)="selectAll(!selectAllCheckmark)"
  ></app-checkbox>
}
<div class="item-container" [ngClass]="type">
  @for (item of itemsList; track $index) {
    <div
      class="item"
      [class.selected]="item.selected"
      [ngbTooltip]="itemTooltip ? tooltip : null"
      [tooltipClass]="'default-tooltip'"
      [placement]="'top'"
      [keepOnHover]="true"
      (click)="selectionItemHandler(item)"
    >
      <ng-template #tooltip>
        <ng-container *ngTemplateOutlet="itemTooltip; context: { item: item.data }"></ng-container>
      </ng-template>

      @if (item.icon) {
        <svg-icon
          preserveAspectRatio="none"
          [class.divided]="item.translationKey || item.text"
          [src]="item.icon"
          [stretch]="true"
        ></svg-icon>
      }
      <span>{{ item.translationKey ? (item.translationKey | translate) : item.text }}</span>
    </div>
  }
</div>
